import Widget from "../../../lib/ui/Widget";
import { observe } from "../../../lib/reactive";
import { C } from "../../../lib/ui/constructors";
import { ClickToCopy } from "../../../lib/ui/ClickToCopy";
var cls = C.cls;
var spacer = C.spacer;
export class SectionControl extends Widget {
    constructor(sections, section_link = null) {
        super(cls("ctr-section-control"));
        this.sections = sections;
        this.entry_buttons = [];
        this.active_entry = observe(null);
        this.active_entry.subscribe(active => {
            this.entry_buttons.forEach(e => {
                const isActive = active == e.original.entry.id;
                e.button.toggleClass("active", isActive);
                if (isActive) {
                    this.content.empty();
                    const header = C.cls("ctr-section-control-content-header")
                        .css("padding-left", "0")
                        .text(e.original.entry.name);
                    if (section_link) {
                        header.css("display", "flex");
                        header.append(spacer(), new ClickToCopy(section_link(active), "Copy direct link"));
                    }
                    this.content.append(header, e.original.entry.renderer());
                    this.content.raw().scrollTo(0, 0);
                }
            });
        });
        this.render();
        this.active_entry.set(sections[0].entries[0].id);
    }
    setActiveSection(id) {
        if (id)
            this.active_entry.set(id);
        return this;
    }
    render() {
        this.empty();
        this.append(this.menu_bar = cls("ctr-section-control-menu"), this.content = cls("ctr-section-control-content"));
        for (const section of this.sections) {
            cls("ctr-section-control-menu-header")
                .text(section.name)
                .appendTo(this.menu_bar);
            for (const entry of section.entries) {
                const button = cls("ctr-section-control-menu-entry")
                    .on("click", () => {
                    this.active_entry.set(entry.id);
                })
                    .text(entry.short_name ?? entry.name)
                    .appendTo(this.menu_bar);
                this.entry_buttons.push({
                    original: { section, entry },
                    button: button
                });
            }
        }
    }
}
